const deleteFiles = (result: string[], index: number) => {
  return result.filter((_, i) => i !== index)
}

export default deleteFiles
